import React from 'react';

const StudentPicker = ({ number }: { number: number }) => {

    const students = [
        "Fabian Guzman",
        "Sebastian Navarro",
        "Valentina Mendez",
        "Fauricio Granados",
        "Amanda Chaves",
        "Luis Jimenez",
        "Mario Brenes",
        "Alexander Bonilla",
        "Alejandro Guillén"
    ];

    const pickRandomStudents = (quantity: number) => {
        const shuffled = students.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, quantity);
    };

    return (
        <>
            <h6>Participación en clase:</h6>
            <ul>
                {pickRandomStudents(number).map((student, index) => (
                    <li className='fragment' key={index}>{student}</li>
                ))}
            </ul>
        </>
    );
};

export default StudentPicker;